import styled from "styled-components"
import Disclosure from "./common/Disclosure"

import docFaqPic from "../../../assets/Mayo/Doctor3.png";
import MayoLogo from "./common/MayoLogo";
import { useState } from "react";
import Back from "./common/Back";

const FAQ_QUESTIONS = [
  {
    Question: "At what time do I go to the hospital?",
    Answer: "An automated text will be sent the evening before the procedure with your report time and location for the next day. If you do not receive a text, or prefer to call for your report time, please contact the Mayo Clinic Service Line at 866-839-5340 between the hours of 7:00 pm and midnight."
  },
  {
    Question: "At what time will my procedure be done?",
    Answer: "The time your procedure will be done is uncertain. Many cases are scheduled for these procedures every day, and the length of each procedure varies. Also, emergency cases are done before nonemergency procedures. Members of your health care team may be able to give you a better idea on the day of your procedure."
  },
  {
    Question: "Can I drive after my procedure?",
    Answer: "You cannot drive the day of procedure. You will need a responsible adult (18 years of age or older) to be present the day of procedure including at discharge for transportation home. If you leave the hospital the day of your procedure, you must stay within 100 miles of the hospital overnight."
  },
  {
    Question: "When will I get my results?",
    Answer: "The physician who ordered the test for you will discuss the results. This will be arranged before you leave the hospital."
  },
]

export default function MayoFAQ() {
  const [openIdx, setOpenIdx] = useState(-1);
  
  const openFaq = (idx) => {
    if(idx === openIdx) {
      setOpenIdx(-1);
    }
    else {
      setOpenIdx(idx);
    }
  }

  return (
  <>
  <MayoLogo/>
  <Back style={{marginTop: 15}}/>
  <Container>

    <Image
      src={docFaqPic}
      height={170}
      width={173}
    />

    <Title>FAQ</Title>

    {FAQ_QUESTIONS.map((fq, i) => 
      <Disclosure 
        key={`Disclosure${i}`}
        title={fq.Question}
        open={i === openIdx}
        openFunc={() => openFaq(i)}
      >
        {fq.Answer}
      </Disclosure>
    )}
  </Container>
  </>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 26px;
  padding-right: 26px;
  height: 100vh;
  background: linear-gradient(
    180deg,
    rgba(255,255,255,0.5) 0%,
    rgba(241,244,251,0.5) 25%,
    rgba(227,232,246,0.5) 50%,
    rgba(245,247,252,0.5) 75%,
    rgba(255,255,255,0.5) 100%
  );
`

const Header = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  width: 100%;
  margin-top: 15px;
`

const BackText = styled.p`
  margin: 0;
  padding: 0;
  color: #7A9DFD;
  font-family: Abraham, Medium;
  font-size: 17px;
  font-weight: 500;
  margin-left: 10px;
`

const Title = styled.p`
  margin: 0;
  font-family: Abraham, Bold;
  font-weight: 700;
  font-size: 30px;
  justify-self: center;
  margin-block: 12px;
  color: #1A1A1A;
`

const Image= styled.img`
  color: #7A9DFD;
`